import React, { useState, useEffect } from 'react'
import { Box, Flex, Group, Button, Input, Tabs, Text, Image, TextInput, Paper } from '@mantine/core'
import { Dropzone } from '@mantine/dropzone'
import { IconPhotoPlus } from '@tabler/icons-react'
import { updateRequestQuote } from '../../../services/request-quote'
import { notificationSuccess, notificationError } from '../../ui/Notifications'
import NoImage from '../../../assets/img/images/no-images.png'


const formValidation = {
  image: {
    isError: false,
    message: ''
  }
}

const FormUploadImages = ({ dataProductQuote, onCloseModal, reloadList }) => {
  const [selectedTab, setSelectedTab] = useState('upload')
  const [validationForm, setValidationForm] = useState(formValidation)
  const [loadingForm, setLoadingForm] = useState(false)
  const [imageUpload, setImageUpload] = useState(null)
  const [imageURL, setImageURL] = useState('')
  const [recentImage, setRecentImage] = useState(null)

  const submitUploadImage = async () => {
    setLoadingForm(true)
    let isError = false
    if (selectedTab === 'upload' && validationForm.image.isError) {
      isError = validationForm.image.isError
    }
    if (isError) {
      notificationError('Upload Image Product Quote Error', `${validationForm.image.message}`)
      setLoadingForm(false)
      return
    }
    let payload = {}
    if (selectedTab === 'upload') {
      payload = {
        supplier_id: dataProductQuote.supplier_id,
        user_id: dataProductQuote.user !== null ? dataProductQuote.user.id : null,
        product_id: dataProductQuote.product_id,
        product_request_id: dataProductQuote.product_request_id,
        product_name: dataProductQuote.product_name,
        quantity_unit: dataProductQuote.quantity_unit,
        weight: dataProductQuote.weight,
        volume: dataProductQuote.volume,
        origin_country_id: dataProductQuote.origin_country_id,
        destination_country_id: dataProductQuote.destination_country_id,
        description: dataProductQuote.description,
        quote_type: dataProductQuote.quote_type.toUpperCase(),
        original_source_url: dataProductQuote.original_source_url,
        sales_by: dataProductQuote.sales_by,
        agent_id: dataProductQuote.agent !== null ? dataProductQuote.agent.id : null,
        package_type: dataProductQuote.package_type,
        terms: dataProductQuote.terms,
        image_encoded: imageUpload
      }
    } else {
      payload = {
        supplier_id: dataProductQuote.supplier_id,
        user_id: dataProductQuote.user !== null ? dataProductQuote.user.id : null,
        product_id: dataProductQuote.product_id,
        product_request_id: dataProductQuote.product_request_id,
        product_name: dataProductQuote.product_name,
        quantity_unit: dataProductQuote.quantity_unit,
        weight: dataProductQuote.weight,
        volume: dataProductQuote.volume,
        origin_country_id: dataProductQuote.origin_country_id,
        destination_country_id: dataProductQuote.destination_country_id,
        description: dataProductQuote.description,
        quote_type: dataProductQuote.quote_type.toUpperCase(),
        original_source_url: dataProductQuote.original_source_url,
        sales_by: dataProductQuote.sales_by,
        agent_id: dataProductQuote.agent !== null ? dataProductQuote.agent.id : null,
        package_type: dataProductQuote.package_type,
        terms: dataProductQuote.terms,
        image_url: imageURL
      }
    }
    try {
      const response = await updateRequestQuote(dataProductQuote.id, payload)
      if (response.success) {
        onCloseModal()
        reloadList()
        notificationSuccess('Update Product Quote Successfully', 'You have been updated data product quote')
      }
    } catch (error) {
      console.log(error)
      const errorMessage = error.response.data.message
      const captionMessageError = Object.keys(errorMessage) ? errorMessage : 'Please recheck your form'
      notificationError('Update Product Quote Error', captionMessageError)
    } finally {
      setLoadingForm(false)
    }
  }

  useEffect(() => {
    if (selectedTab === 'upload') {
      setImageURL('')
    } else {
      setImageUpload(null)
    }
  }, [selectedTab])

  useEffect(() => {
    if (dataProductQuote) {
      handleSetForm(dataProductQuote)
    }
    // eslint-disable-next-line
  }, [dataProductQuote])

  const handleSetForm = (value) => {
    setRecentImage(value.image)
  }

  const handleUploadImage = (file) => {
    setValidationForm(formValidation)
    const fileEncoded = file[0]
    const fileReader = new FileReader()
    fileReader.readAsDataURL(fileEncoded)
    fileReader.onload = (reader) => {
      setImageUpload(reader.target.result)
    }
  }

  const handleErrorFile = (file) => {
    setValidationForm(formValidation)
    const fileState = Object.values(file)
    const errorMessage = fileState[0].errors[0].message
    if (errorMessage) {
      const error = {
        image: {
          isError: true,
          message: errorMessage
        }
      }
      setValidationForm(error)
    }
  }

  const handleSelectedImage = () => {
    if (selectedTab === 'upload' && imageUpload !== null) {
      return imageUpload
    } else if (selectedTab === 'url' && imageURL !== '') {
      return imageURL
    } else if (recentImage) {
      return recentImage
    }
    return NoImage
  }
  
  return (
    <Box>
      <Box h={300} mb='md'>
        <Tabs size='xs' my={4} value={selectedTab} onChange={setSelectedTab}>
          <Tabs.List>
            <Tabs.Tab value="upload">Upload Image File</Tabs.Tab>
            <Tabs.Tab value="url">Upload Image URL</Tabs.Tab>
          </Tabs.List>
          <Tabs.Panel value="upload">
            <Input.Wrapper my={10} label='Upload Product Photo (Optional)' size='xs' error={validationForm.image.isError ? `${validationForm.image.message}` : ''}>
              <Box my={10}>
                <Dropzone 
                  accept={[
                    'image/png',
                    'image/jpeg',
                    'image/gif',
                  ]}
                  onDrop={(files) => handleUploadImage(files)}
                  onReject={(files) => handleErrorFile(files)}
                  maxSize={2000000}
                >
                  <Box ta='center' my={30}>
                    <Flex justify='center' mb={10}>
                      <IconPhotoPlus size={50} color='gray' />
                    </Flex>
                    <Box>
                      <Text fz={12} c='blue.9'>Upload Image Here</Text>
                      <Text fz={12} c='gray.6'>PNG, JPG, GIF up to 2 MB</Text>
                    </Box>
                  </Box>
                </Dropzone>
              </Box>
            </Input.Wrapper>
          </Tabs.Panel>
          <Tabs.Panel value="url">
            <Box my={10}>
              <TextInput
                name='imageURL'
                value={imageURL}
                label='Image URL'
                placeholder='Input image URL'
                onChange={(val) => setImageURL(val.target.value)}
                size='xs'
              />
            </Box>
          </Tabs.Panel>
        </Tabs>
      </Box>
      <Box mb='md'>
        <Text fz={12} fw='500' mb='sm'>Recent / Review Image</Text>
        <Paper shadow="sm" withBorder radius='md' style={{ backgroundColor: '#f1f2f5' }}>
          <Flex justify='center'>   
            <Image src={handleSelectedImage()} w='auto' radius='md' h={250} fit='contain' />
          </Flex>
        </Paper>
      </Box>
      <Box mt={20}>
        <Flex justify='flex-end'>
          <Group>
            <Button size='xs' variant="outline" onClick={onCloseModal}>Close</Button>
            <Button size='xs' loading={loadingForm} variant="filled" onClick={() =>submitUploadImage()} disabled={imageUpload === null && imageURL === ''}>Submit</Button>
          </Group>
        </Flex>
      </Box>
    </Box>
  )
}

export default FormUploadImages